import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import welcomepic from "../../../assets/images/wellcomepic.svg";
import { useGetUserApprovedAccounts } from "../../../lib/queries/queriesAndMutations";
import BussinessForm from "../../forms/BussinessForm";
import Loader from "../../shared/Loader";
import Hint from "../Hint";

const NewBusiness = () => {
  const { data: userHaveAprovedAccount, isLoading } = useGetUserApprovedAccounts();
  const navigate = useNavigate();
  const handleNewAccount = useCallback(() => navigate("/accounts/new"), [navigate]);

  if (isLoading) {
    return (
      <div className="w-full h-full flex justify-center items-center">
        <Loader />
      </div>
    );
  }

  if (!userHaveAprovedAccount) {
    return (
      <div className="w-full h-full flex justify-center items-center  ">
        <div className="flex flex-col items-center gap-6 p-6 bg-white max-w-[700px]   rounded-xl shadow-md w-fit">
          <Hint
            hintStyle={"entry"}
            response={"mobile"}
            hintImage={true}
            title={"متاسفانه هنوز حساب فعالی برای شما وجود ندارد"}
            entry={"flex justify-center items-center"}
          >
            <p className="flex justify-center items-center mb-4">
              برای افزودن اولین حساب، کافی است بر روی دکمه زیر کلیک نمایید و ادامه فرایند را طی کنید.
            </p>
          </Hint>
          <button onClick={handleNewAccount} className="main-btn w-full ">
            افزودن حساب جدید
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col xl:flex-row-reverse  w-full gap-2.5 p-2 md:rounded-xl  ">
      <div className="flex flex-col  md:flex-row-reverse xl:flex-col xl:h-fit xl:max-w-[400px] gap-6   bg-white p-6 rounded-[24px]">
        <img className="w-full md:w-1/2 xl:w-full  " src={welcomepic} alt="welcome-pic" />
        <div className="flex flex-col flex-1 gap-2">
          <p className="text-[18px] font-semibold">راهنما</p>
          <p
            className="w-full  text-[14px] md:text-[16px] text-gray-700 h-full no-scrollbar pointer-events-none  leading-7 "
            readOnly
          >
            وارد کردن اطلاعات کسب‌وکارتان و همچنین بارگذاری مدارک آن برای پیمودن مراحل بعدی الزامیست و تمام
            این اطلاعات بصورت محرمانه نزد وندا‌پرداخت نگه داشته می‌شود و پرداخت‌کننده، دسترسی به این اطلاعات
            ندارد! در صورتی که به صورت حقیقی (یا حقوقی) در ونداپرداخت ثبت کسب‌وکار می‌کنید، شبای شما باید متصل
            به حساب کسب‌وکار حقیقی (یا حقوقی) شما باشد.
          </p>
        </div>
      </div>

      <div className="w-full">
        <BussinessForm type={"add"} />
      </div>
    </div>
  );
};

export default NewBusiness;
